import {React,useContext,useEffect, useState} from 'react'
import {conitem } from '../context/Contextitem'
import {DownIcon, TrashIcon,UpIcon} from '../context/Icon'
import {useNavigate,Link} from 'react-router-dom'
import styled from 'styled-components'
import Nav from './Nav';
import { Footer } from './Footer1';


export const Basket = () => {
 
  const navigate = useNavigate()
  const {getitem,addition,clearBasket,reduction,del}= useContext(conitem )
  let [bolu ,setbolu] = useState([])
  
  useEffect(()=>{
    setbolu(getitem())
  },[getitem])

    
  const totalamount  = bolu.reduce((acc,item)=>{
 
    const totalprice = item.price * item.quality
    return acc+totalprice
  },0)




  const rerender = ()=>{
    if(bolu.length>0){
    
 return bolu.map(data=>(
  
  <BasketTableWrapper key={data.id} >
 
    <div id='bastketproduct-wrapper'>
     <img style={{width:'50px',marginRight:'20px'}} src={`/asset/${data.image}`}/>
  <div className='basket-product-title'><Link to={`/product/${data.id}`}>{data.title}</Link></div>
  </div>
  < QualityBtn>
   <div >{data.quality}</div>
     <UpIcon width={'20px'}  onClick={()=>setbolu(addition({id :data.id}))}/>
    <DownIcon width={'20px'}  onClick={()=>setbolu(reduction({id:data.id}))}/> 
   <TrashIcon width={'20px'} onClick={()=>setbolu(del({id:data.id}))}/>      
    </QualityBtn>
 
  <div  className='product-price'> {data.price}</div>
 
  
  </BasketTableWrapper>
))
}
else{
    return  <div> Cart empty</div>
}
  
  }
 

  return (
    <>
      <Nav/>
    {/* <div id='level'> */}
    {/* <BasketWrapper > */}
      <ShoppingBasket>
        <h4>Shopping Basket</h4>
        <ShoppingBasketBtn onClick={()=>navigate('/checkout')} >Checkout</ShoppingBasketBtn>
      </ShoppingBasket>
      <BasketHeader>
        <h4>Title</h4>
        <h4>Quality</h4>
        <h4>Price</h4>
       
      </BasketHeader>
      <UnderLine/>
      <div className='Product-value' >
     { rerender()}

      </div>
      <UnderLine/>
      <ClearBtnWrapper>
      <ClearBtn onClick={()=>setbolu(clearBasket({type:'remove'}))}> Clear</ClearBtn>
     <h1>Total : {totalamount}</h1>
      </ClearBtnWrapper>
    
    
    {/* </BasketWrapper> */}
    {/* </div> */}
    <div id='service-wrapper'>

<div >
<img src={`/asset/Group.png`}/>
<h6>FREE AND FAST DELIVERY</h6>
<p>Free delivery for all orders over $140</p>
</div>


<div >
<img src={`/asset/Services.png`}/>
<h6>24/7 CUSTOMER SERVICE</h6>
<p>Friendly 24/7 customer support</p>
</div>

<div >
<img src={`/asset/Servicess.png`}/>
<h6>MONEY BACK GUARANTEE</h6>
<p>We reurn money within 30 days</p>
</div>

</div>

    <Footer/> 
    </>
  )
}


const BasketTableWrapper = styled.div`
display: grid;
grid-template-columns: 0.4fr   0.4fr  0.4fr;
column-gap: 30px;
padding: 20px 20px;
margin-top: 20px;
margin: 10px 0;
height :;
@media (min-width:380px){
  display: grid;
  grid-template-columns: 5fr   3fr  2fr;
  grid-template-row: 1fr   1fr  1fr;
  padding: 10px 12px;
  padding-left :15px;

}

@media (min-width:600px){
  display: grid;
  grid-template-columns: 6fr   3fr  3fr;
  grid-template-row: 1fr   1fr  1fr;
  padding: 10px 12px;
  padding-left :15px;
 
  

}

@media (min-width:770px){
height :15vh;
 
  

}


`
const QualityBtn = styled.div`
display: flex;
align-items: center;
width:60px;
`
const ShoppingBasket = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding: 0 20px;
margin: 30px 0;
background-color : 'red';
`
const ShoppingBasketBtn =  styled.button`
padding: 5px 20px;
font-size: 20px;
font-weight: 500;
`
const BasketWrapper= styled.div`
border-bottom: 1px solid black
width : 100%

@media (min-width:600px){
  padding :300px;
  background-color:red;

}
`

const ClearBtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin : 0 30px;

`
const ClearBtn = styled.button`
padding: 5px 20px;
font-size: 20px;
font-weight: 500;
`
const BasketHeader= styled.div`
display: grid;
grid-template-columns: 0.4fr   0.4fr  0.4fr;
margin: 0 40px;
width : 100%
column-gap: 200px;

@media (min-width:380px){
  display: grid;
  grid-template-columns: 5fr   3fr  0.9fr;
}

@media (min-width:600px){
  display: grid;
  grid-template-columns: 5fr   3fr  2fr;
  grid-template-row: 1fr   1fr  2fr;
  padding: 10px 12px;
  padding-left :15px;

}

`

const UnderLine = styled.hr`
border: 1px solid black;
  
color: black;
font-size: 20px;
font-weight: 800;
grid-column: 1/span3;
margin: 0;
padding:0;
margin-bottom: 20px;
`